// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

import { TimelineMax, TweenMax } from 'gsap';

import { Component } from '@verndale/core';
import ScrollMagic from 'ScrollMagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      hiddenWord: this.el.querySelector('.hidden-word'),
      videoWrapper: this.el.querySelector('.video-content-v2__video'),
      titleWrapper: this.el.querySelector('.video-content-v2__title-wrapper')
    };
    this.controller = new ScrollMagic.Controller();
    this.setIsMobile();
    this.setHeight();
    this.wordAnimation();
  }

  addListeners() {
    window.addEventListener('resize', this.setHeight.bind(this));
  }

  setIsMobile() {
    this.isMobile = window.matchMedia('(max-width: 677px)').matches;
  }

  setHeight() {
    this.setIsMobile();

    if (this.isMobile) {
      this.el.closest('.container').style.overflowX = 'unset';
      return this.dom.titleWrapper.removeAttribute('style');
    }
    this.dom.titleWrapper.style.height = `${this.dom.videoWrapper.offsetHeight}px`;
  }

  wordAnimation() {
    const tl = new TimelineMax();

    TweenMax.set(this.dom.hiddenWord, { left: 0 });

    tl.add(TweenMax.to(this.dom.hiddenWord, 1, { left: '100%' }));

    new ScrollMagic.Scene({
      triggerElement: this.el,
      duration: this.dom.titleWrapper.offsetHeight,
      offset: this.isMobile ? '-200px' : '-200px'
    })
      .setTween(tl)
      .addTo(this.controller);
    // .addIndicators({ name: '1 (duration: 0)' }); // add indicators (requires plugin)
  }
}

export default Module;
